import React from "react"
import { Breadcrumb } from "antd"
import { useNavigate } from "react-router-dom"

import { useProjectStore } from "stores/projectStore"

import { truncateName } from "utils/truncateName"

/**
 * Renders the breadcrumb navigation for a project.
 *
 * This component displays breadcrumb links for navigating back to the home page
 * and to the current project.
 *
 * @component
 * @returns The rendered ProjectBreadcrumb component.
 */
const ProjectBreadcrumb: React.FC = () => {
  const navigate = useNavigate()
  const project = useProjectStore((state) => state.project)

  /**
   * Handles navigation to the home page
   */
  const handleNavigateHome = (): void => {
    navigate("/home")
  }

  return (
    <Breadcrumb
      items={[
        // Breadcrumb link for the home page
        {
          title: "Project",
          onClick: handleNavigateHome,
          className: "cursor-pointer",
        },
        // Breadcrumb link for the current project
        {
          title: truncateName(project.Name, 30),
          className: "cursor-pointer",
        },
      ]}
    />
  )
}

export default ProjectBreadcrumb
